/**
 * TopDownButton — flatten the camera to a runway-aligned top-down view so the
 * airfield network is legible for inspecting/authoring taxi waypoints. Toggles
 * back to the prior perspective on a second click (see useTopDownCamera).
 */
import { Compass } from 'lucide-react'
import { ToolbarButton } from './ToolbarButton'

interface TopDownButtonProps {
  active: boolean
  onToggle: () => void
  fullWidth?: boolean
}

export function TopDownButton({ active, onToggle, fullWidth }: TopDownButtonProps) {
  return (
    <ToolbarButton
      icon={<Compass className="h-4 w-4" />}
      label="Top-down"
      accent="sky"
      active={active}
      fullWidth={fullWidth}
      onClick={onToggle}
      title="Top-down view (flatten + align to runway)"
    />
  )
}
